import { StatsApiSchedule } from "../types/Stats";
import StatsApiClient from "./StatsClient";

export const getStatsEvent = async (gamePk: number | string): Promise<StatsApiSchedule> =>
  getSchedule(`gamePk=${gamePk}`);

export const getSchedule = async (queryParams: string): Promise<StatsApiSchedule> =>
  (await StatsApiClient.get(`v1/schedule?sportIds=1${queryParams?.length ? `&${queryParams}` : ""}`)).data;
